import { useNavigate } from "react-router-dom";
import { Building2, Store, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function DiventaPartner() {
  const navigate = useNavigate();
  return (
    <div>
      <section className="bg-cream">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16">
          <span className="text-xs uppercase tracking-[0.2em] font-semibold text-orange">Diventa partner</span>
          <h1 className="mt-3 text-4xl lg:text-5xl font-extrabold text-navy tracking-tight max-w-3xl">Entra nella prima rete locale delle colazioni</h1>
          <p className="mt-4 text-lg text-navy/70 max-w-2xl leading-relaxed">
            Stiamo selezionando i primi partner MorningBox. Scegli il profilo adatto a te e inizia la registrazione: il nostro team ti contatterà prima dell'attivazione.
          </p>
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-5 lg:px-8 py-16 grid md:grid-cols-2 gap-6">
        <div className="bg-white border border-navy/10 rounded-3xl p-10 hover:shadow-lg transition-shadow">
          <div className="w-14 h-14 rounded-2xl bg-navy flex items-center justify-center"><Building2 className="w-7 h-7 text-orange" /></div>
          <h2 className="mt-5 text-2xl font-bold text-navy">Sono un B&B</h2>
          <p className="mt-2 text-navy/60 leading-relaxed">Affittacamere, B&B e piccoli hotel che vogliono offrire colazioni di qualità ai propri ospiti.</p>
          <Button onClick={() => navigate("/registra/bnb")} className="mt-6 rounded-full bg-navy text-white h-12 px-6" data-testid="partner-bnb-btn">
            Registra il tuo B&B <ArrowRight className="w-4 h-4 ml-1" />
          </Button>
        </div>
        <div className="bg-white border border-navy/10 rounded-3xl p-10 hover:shadow-lg transition-shadow">
          <div className="w-14 h-14 rounded-2xl bg-orange flex items-center justify-center"><Store className="w-7 h-7 text-white" /></div>
          <h2 className="mt-5 text-2xl font-bold text-navy">Sono un bar o pasticceria</h2>
          <p className="mt-2 text-navy/60 leading-relaxed">Bar e pasticcerie che vogliono raggiungere nuovi clienti tra gli ospiti dei B&B della zona.</p>
          <Button onClick={() => navigate("/registra/locale")} className="mt-6 rounded-full bg-orange hover:bg-orange-600 text-white h-12 px-6" data-testid="partner-vendor-btn">
            Registra il tuo locale <ArrowRight className="w-4 h-4 ml-1" />
          </Button>
        </div>
      </section>
    </div>
  );
}
